<div class="share-joint-security-holder">
  <div class="header">{{ label }}</div>
    <ul class="joint-holders-list ">
      @for (holder of value; track holder; let index = $index) {
        <li class="holder-item">
          <app-security-holder-icon-label [holder]="holder"></app-security-holder-icon-label>

          <button
            class="edit-icon"
            type="button"
            [disabled]="disabled"
            (click)="onEditHolder(holder)"
          >
            <i class="icon ic-edit-20"></i>
          </button>

          <button
            class="delete-icon"
            type="button"
            [disabled]="disabled"
            (click)="onDeleteHolder(holder)"
          >
            <i class="icon ic-close-20"></i>
          </button>
        </li>
      }
    </ul>

    <div class="addition-controls">
      <app-button
        iconClass="icon ic-add-20"
        text="Add individual"
        [isDisabled]="disabled"
        (clickBtn)="addIndividual()"
      ></app-button>
      <app-button
        iconClass="icon ic-add-20"
        text="Add corporate"
        [isDisabled]="disabled"
        (clickBtn)="addCorporate()"
      ></app-button>
    </div>
</div>
